const create = (api) => {
  // This service provides methods to interact with system notifications banner. 
  const getSystemNotifications = (language='en-US') => {
    return api.get(`/systemnotifications?language=${language}`);
  }  
  // This method is used to post to system notification attested database.
  const postSystemNotifications = (notificationId) => {
    return api.post(`/systemnotifications/${notificationId}/attested`);
  } 
  
  return {
    getSystemNotifications,
    postSystemNotifications
  }
}

export default {
    create
}
